import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { SingleOrientationFilter } from "~/components/Filters/OrientationFilter/SingleOrientationFilter";
import { FilterTrigger } from "~/components/Filters/SingleFilters/FilterTrigger";
import { baseFiltersOptions } from "~/components/FiltersMenu/types";
import { useFilterParams } from "~/hooks/filters/useFilterParams";
import { removeFilterAction } from "~/store/filters/actions";
export const OrientationFilterTrigger = /*#__PURE__*/ memo((param)=>{
    let { onApplyClick, onRemoveClick, onOpenChange } = param;
    var _orientationsParam_or;
    const dispatch = useDispatch();
    const { orientationsParam } = useFilterParams();
    const content = useMemo(()=>/*#__PURE__*/ _jsx(SingleOrientationFilter, {
            onApplyClick: onApplyClick
        }), [
        onApplyClick
    ]);
    var _orientationsParam_or_length;
    const appliedOrientationsCount = (_orientationsParam_or_length = orientationsParam === null || orientationsParam === void 0 ? void 0 : (_orientationsParam_or = orientationsParam.or) === null || _orientationsParam_or === void 0 ? void 0 : _orientationsParam_or.length) !== null && _orientationsParam_or_length !== void 0 ? _orientationsParam_or_length : (orientationsParam === null || orientationsParam === void 0 ? void 0 : orientationsParam.is) ? 1 : 0;
    const removeFilter = useCallback(()=>{
        const filter = {
            type: "orientation"
        };
        dispatch(removeFilterAction({
            filter
        }));
        onRemoveClick === null || onRemoveClick === void 0 ? void 0 : onRemoveClick([
            filter
        ]);
    }, [
        dispatch,
        onRemoveClick
    ]);
    return /*#__PURE__*/ _jsx(FilterTrigger, {
        onRemoveClick: removeFilter,
        count: appliedOrientationsCount,
        filterContent: content,
        title: baseFiltersOptions["orientation"].label,
        Icon: baseFiltersOptions["orientation"].icon,
        onOpenChange: onOpenChange
    });
});
OrientationFilterTrigger.displayName = "OrientationFilterTrigger";
